import { element } from "protractor";
import {
  Component,
  OnInit,
  AfterViewInit,
  HostListener,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment-taxi-directo";
import { DefaultComponent } from "../../default/default/default.component";
import { PopoverConfig } from "ngx-bootstrap/popover";
import { Subscription } from "rxjs/internal/Subscription";
import { DatosCompartidosService } from "../../service/datos-compartidos.service";
import {
  AccordionAnimation,
  SlideInOutAnimation,
} from "../../animations/animations-nexus";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Menu } from "../../clases/menu";
import { ClienteAsociado } from "src/app/clases/clienteAsociado";
import { modalService } from "../../service/modal.service";
import * as Cookie from "../../util/cookies/cookies";
import { faElementor } from "@fortawesome/free-brands-svg-icons";
import { CookieService } from "ngx-cookie-service";
import { PromocionesService } from "../../service/promociones.service";
@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.css"],
  animations: [SlideInOutAnimation, AccordionAnimation],
})
export class MenuComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("templatechildModal", { static: true })
  templatechildModal: TemplateRef<any>;
  modalBuscar: BsModalRef;
  route: string;
  // idUsuario = '99815'; // Dario = 99815
  ADMIN_CORPORATIVO: number = environment.ROL.ADMIN_CORPORATIVO;
  ADMIN: number = environment.ROL.ADMIN;
  PARTICULAR: number = environment.ROL.PARTICULAR;
  CORPORATIVO: number = environment.ROL.CORPORATIVO;
  // imgUser = environment.URL_BASE + 'cliente/getpicture?id=' + this.idUsuario;
  usuario: string;
  dataSubscription: Subscription;
  data: any;
  state = "out";
  isCollapsed: boolean = false;

  listaMenu: Menu[] = [];

  //Modal
  modalRef: BsModalRef;
  modalPerfil: BsModalRef;

  NOMBRE_EMPRESA = environment.NOMBRE_EMPRESA;
  COD_EMPRESA = environment.CODCLIENTE;

  //LogoEmpresa
  logo = {
    src: environment.LOGO.URL,
    alt: environment.LOGO.ALT,
    width: environment.LOGO.WIDTH,
  };

  logoMenu = {
    src: environment.LOGO_MENU.FLAG
      ? environment.LOGO_MENU.URL
      : environment.LOGO.URL,
    alt: environment.LOGO_MENU.FLAG
      ? environment.LOGO_MENU.ALT
      : environment.LOGO.ALT,
    width: environment.LOGO_MENU.FLAG
      ? environment.LOGO_MENU.WIDTH
      : environment.LOGO.WIDTH,
  };

  //OpcionesDesarrollo
  opcionesDesarrollo: boolean = environment.OPCIONES_DESARROLLO;

  //VersionEmpresa
  version: string = "Version " + environment.VERSION; //environment.VERSION;
  versionFlag: boolean = false;
  //cliente Asociado
  lstAsociado: ClienteAsociado[] = [];
  intervalo: any;

  open: boolean = true;
  disabled: boolean = true;

  beneficiosConductor: any = {
    has: false,
    order: 0,
    permission: false,
  };

  reporteDeConductores: any = {
    has: false,
    order: 0,
    permission: false,
  };

  cargaMasiva: any = {
    has: false,
    order: 0,
    permission: false,
  };

  cargaMasivaUsuarios: any = {
    has: false,
    order: 0,
    permission: false,
  };

  promos: any = {
    has: false,
    order: 0,
    permission: false,
  };

  cargoNoComisionable: any = {
    has: false,
    order: 0,
    permission: false,
  };

  isWebAdmin = false;

  constructor(
    private router: Router,
    private defaultC: DefaultComponent,
    private _datosCompartidos: DatosCompartidosService,
    private modalService: BsModalService,
    private modal: modalService,
    private CookieService: CookieService,
    private _reporteService: PromocionesService
  ) {
    this.route = router.routerState.snapshot.url;
  }

  ngOnInit() {
    this.dataSubscription = this._datosCompartidos.user$.subscribe((data) => {
      this.data = data;
      console.log(this.data);
    });
    if (this.data.menu != undefined) {
      //this.listaMenu = this.data.menu;
      this.data.menu.forEach((elemento) => {
        if (environment.DELIVERY && elemento.id == 1) {
          elemento.icon = "two_wheeler";
        }
        if (!elemento.desarrollo) this.listaMenu.push(elemento);
        else {
          if (this.opcionesDesarrollo) {
            this.listaMenu.push(elemento);
          }
        }
      });
      this.listaMenu.sort((a, b) => {
        if (a.Orden < b.Orden) return -1;
        else if (a.Orden > b.Orden) return 1;
        else return 0;
      });
      this.listaMenu.forEach((elemento) => {
        if (
          elemento.route == "comision-reducida" ||
          elemento.route == "bono" ||
          elemento.route == "reporte-bono" ||
          elemento.route == "reporte-estrellas"
        ) {
          this.beneficiosConductor.has = true;
          this.beneficiosConductor.order = elemento.Orden;
        }
      });
      this.listaMenu.forEach((elemento) => {
        if (
          elemento.route == "reporte-rechazo" ||
          elemento.route == "tasa-de-cancelacion" ||
          elemento.route == "reporte-proxima-conexion"
        ) {
          this.reporteDeConductores.has = true;
          this.reporteDeConductores.order = elemento.Orden;
        }
      });
      this.listaMenu.forEach((elemento) => {
        if (
          elemento.route == "cargar-datos" ||
          elemento.route == "eliminar-datos"
        ) {
          this.cargaMasiva.has = true;
          this.cargaMasiva.order = elemento.Orden;
        }
      });
      this.listaMenu.forEach((elemento) => {
        if (
          elemento.route == "cargar-usuarios" ||
          elemento.route == "actualizar-usuarios"
        ) {
          this.cargaMasivaUsuarios.has = true;
          this.cargaMasivaUsuarios.order = elemento.Orden;
        }
      });
      this.listaMenu.forEach((elemento) => {
        if (
          elemento.route == "promociones" ||
          elemento.route == "registro-promociones" ||
          elemento.route == "reporte-promociones"
        ) {
          this.promos.has = true;
          this.promos.order = elemento.Orden;
        }
      });
      this.listaMenu.forEach((elemento) => {
        if (
          elemento.route == "recargo-reserva"
        ) {
          this.cargoNoComisionable.has = true;
          this.cargoNoComisionable.order = elemento.Orden;
        }
      });
    }
    if (
      ((this.data.IdEmpresa == 13361 || this.data.IdEmpresa == 128) &&
        this.data.Rol == 13) ||
      this.data.Rol == 1
    ) {
      this.beneficiosConductor.permission = true;
      this.reporteDeConductores.permission = true;
    }
    if (
      ((this.data.IdEmpresa == 13361 || this.data.IdEmpresa == 128) &&
        this.data.Rol == 13) ||
      this.data.Rol == 1
    ) {
      this.cargaMasiva.permission = true;
      this.cargaMasivaUsuarios.permission = true;
    }
    
    // Validar acceso a reporte de promociones usando endpoint
    this._reporteService.GetRequiereClaveReportePromociones(this.data.IdEmpresa, this.data.Rol).subscribe(
      (data: any) => {
        // Si el endpoint retorna sin error, el usuario tiene acceso
        this.promos.permission = true;
      },
      (error: any) => {
        // Si hay error o no tiene acceso, no mostramos el permiso
        this.promos.permission = false;
      }
    );
    
    if(this.data.Rol == 1 || 
       ((this.data.IdEmpresa == 13361 || this.data.IdEmpresa == 128) && this.data.Rol == 13)){
      this.cargoNoComisionable.permission = true;
    }
    this.lstAsociado = this.data.lstAsociados;
    this.usuario = this.data.NombreCompleto;

    this.isWebAdmin = environment.URL_BASE.includes("integracion_admin");

    //Supervisor corporativo de proaccion entrando web admin
    if (
      this.data.Rol == 13 &&
      (this.data.IdEmpresa == 128 || this.data.IdEmpresa == 13361) &&
      this.isWebAdmin
    ) {
      var i = this.listaMenu.findIndex((e) => e.route === "solicitar-servicio");
      if (i > -1) {
        this.listaMenu.splice(i, 1);
      }
      var j = this.listaMenu.findIndex((e) => e.route === "envios");
      if (j > -1) {
        this.listaMenu.splice(j, 1);
      }
    }

    //Supervisor corporativo de proaccion entrando web intranet
    if (
      (this.data.Rol == 13 || this.data.Rol == 6) &&
      (this.data.IdEmpresa == 128 || this.data.IdEmpresa == 13361) &&
      !this.isWebAdmin
    ) {
      this.listaMenu = this.listaMenu.filter(x => x.route === "solicitar-servicio" || x.route === "envios" || x.route === "cerrar-sesion" || x.route === "usuarios" || x.route === "cuenta" || x.route === "reporte-empresarial" || x.route === "editar-servicio" || x.route === "centro-costo" || x.route === "reporte-aprobacion");
    }

    //usuario de otra empresa entrando web intranet
    if (
      (this.data.IdEmpresa != 128 && this.data.IdEmpresa != 13361) &&
      !this.isWebAdmin
    ) {
      var lstMenuAux = this.listaMenu;

      console.log(this.listaMenu)

      this.listaMenu = lstMenuAux.filter(x => x.route === "solicitar-servicio" || x.route === "envios" || x.route === "cerrar-sesion" || x.route === "usuarios" || x.route === "cuenta" || x.route === "reporte-empresarial" || x.route === "editar-servicio" || x.route === "centro-costo" || x.route === "reporte-aprobacion" || x.route === "promociones");
      console.log(this.listaMenu)
      if(this.data.IdEmpresa == 13235 && this.data.Rol == 5){
        //LATAM ADMIN CORP
        this.listaMenu = [...this.listaMenu, ...lstMenuAux.filter(x => x.route === "tracking-conductores" || x.route === "monitoreo-latam")].sort((a, b) => a.Orden - b.Orden);;
      }
    }
  }

  ngAfterViewInit(): void {
    this.dataSubscription = this._datosCompartidos.user$.subscribe((data) => {
      this.data = data;
    });

    this.verificarOpcion();

    this.recalcularTamañoMapa();
  }

  verificarOpcion() {
    this.listaMenu.sort((a, b) => a.id);

    for (let index = 0; index < this.listaMenu.length; index++) {
      const element = this.listaMenu[index];
      const i = this.route.indexOf(element.route);
      if (i != -1) {
        this.marcarOption(this.listaMenu[index].id);
        return;
      }
    }
  }
  selectOption(opcWeb: number, opcMob: number) {
    let options = document.getElementsByClassName("nav-link menu-option");
    for (let index = 0; index < options.length; index++) {
      const element = options[index];
      element.classList.remove("active");
    }
    if (options[opcWeb] != undefined) options[opcWeb].classList.add("active");
    if (options[opcMob] != undefined) options[opcMob].classList.add("active");
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    event.target.innerWidth;
    this.isMobile();
    this.verificarOpcion();
    this.recalcularTamañoMapa();
  }

  recalcularTamañoMapa() {
    const container = document.getElementById("layout-main");
    // console.log("recalcular " + this.route);

    if (window.innerWidth <= 1024) {
      if (
        this.route == "/default" ||
        this.route == "/default/solicitar-servicio"
      ) {
        if (!container.classList.contains("mapaSolicitarServicio")) {
          container.classList.add("mapaSolicitarServicio");
        }
      } else {
        container.classList.remove("mapaSolicitarServicio");
      }
    } else {
      container.classList.remove("mapaSolicitarServicio");
    }
  }
  diseñoContainerMap() {
    this.route = this.router.routerState.snapshot.url;
    const container = document.getElementById("layout-main");
    container.style.paddingLeft = "15px";
  }

  isMobile() {
    const menu = document.getElementById("menu");
    const content = document.getElementById("layout-main");
    const search = document.getElementById("search");

    if (window.innerWidth <= 1024) {
      menu.classList.remove("col-md-2");
      menu.classList.remove("sidebar");
      menu.classList.add("menu-mobile");

      content.classList.remove("col-md-10");
      content.classList.add("layout-mobile");

      if (search != undefined) {
        search.classList.add("search-container-mobile");
      }
      return true;
    } else {
      menu.classList.add("col-md-2");
      menu.classList.add("sidebar");
      menu.classList.remove("menu-mobile");

      content.classList.add("col-md-10");
      content.classList.remove("layout-mobile");

      if (search != undefined) {
        search.classList.remove("search-container-mobile");
      }

      return false;
    }
  }

  onImgError(event) {
    event.target.src = environment.IMAGEN_USUARIO_URL;
  }

  logout() {
    this.modalRef.hide();

    if(document.location.href.includes("admin")){
      localStorage.removeItem("activeUserWebAdmin");
    }else if(document.location.href.includes("intranet")){
      localStorage.removeItem("activeUserIntranet");
    }
    Cookie.cookieTokenRemove();
    localStorage.removeItem("country");
    this.router.navigate(["/"]);
    Cookie.removeCookie(Cookie.tokenCookieName);
    //localStorage.clear();
    localStorage.removeItem("cookieConsent");
    localStorage.removeItem("gps");
    this.CookieService.deleteAll();
  }

  public ngOnDestroy(): void {
    this.dataSubscription.unsubscribe();
  }
  toggleState() {
    this.state = this.state === "out" ? "in" : "out";
  }

  decline(): void {
    this.modalRef.hide();
  }

  marcarOption(id: number) {
    let options = document.getElementsByClassName("nav-link");
    for (let index = 0; index < options.length; index++) {
      const element = options[index];
      element.classList.remove("active");
    }

    const marcado = document.getElementsByClassName("option-" + id);
    if (marcado != undefined) {
      for (let index = 0; index < marcado.length; index++) {
        const element = marcado[index];
        element.classList.add("active");
      }
      this.modalService.hide(1);
    }
  }

  cerrarSesion(template: TemplateRef<any>, id: number) {
    // debugger
    this.state = "out";
    if (id == environment.MENU.CERRAR_SESION) {
      this.modalRef = this.modalService.show(template, {
        class: "modal-confirm",
        backdrop: "static",
      });
    } else {
      if (id != 1) {
        this.diseñoContainerMap();
      }
      this.marcarOption(id);
      for (let index = 0; index < this.listaMenu.length; index++) {
        if (this.listaMenu[index].id == id) {
          // this.modal.cargar();
          var ruta = this.listaMenu[index].route;
          this.router.navigate(["default/" + ruta]);
          // this.modal.ocultarModal();
        }
      }
    }
  }
  perfilUsuario(template: TemplateRef<any>) {
    let url: string = this.router.url;
    this.lstAsociado.forEach((element) => {
      element.url =
        "https://web.alotaxis.com/integration_test/api/cliente/getpicture?id=" +
        element.id_cliente;
    });
    this.modalPerfil = this.modalService.show(template, {
      class: "modal-confirm",
      backdrop: "static",
    });
  }

  cambiarCuenta(asociado: ClienteAsociado) {
    this.modalPerfil.hide();
    localStorage.removeItem("activeUserWebAdmin");
    localStorage.removeItem("activeUserIntranet");

    const currentUser = {
      IdCliente: asociado.id_cliente,
      Rol: asociado.rol,
    };

    if(document.location.href.includes("admin")){
      localStorage.setItem(
        "activeUserWebAdmin",
        JSON.stringify(currentUser)
      );
    }else if(document.location.href.includes("intranet")){
      localStorage.setItem(
        "activeUserIntranet",
        JSON.stringify(currentUser)
      );
    }


    let url: string = this.router.url;
    sessionStorage.setItem(
      "reloadPage" + "_" + environment.NOMBRE_EMPRESA,
      JSON.stringify(url)
    );
    window.location.reload();
  }

  log(isOpened: boolean) {
    console.log(isOpened);
  }
}

export function getPopoverConfig(): PopoverConfig {
  return Object.assign(new PopoverConfig(), {
    placement: "bottom",
    container: "body",
    // triggers: 'focus'
  });
}
